import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const patchPostSharingSettings = async ({
  companyId,
  postId,
  postSharingSettings,
}) => {
  let postSharingSettingsUpdate;
  try {
    postSharingSettingsUpdate = await axios.patch(
      `/api/v2/companies/${companyId}/posts/${postId}/sharing_settings`,
      postSharingSettings
    );
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return postSharingSettingsUpdate.data;
};

export default function usePatchPostSharingSettings() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ companyId, postId, postSharingSettings }) =>
      await patchPostSharingSettings({
        companyId,
        postId,
        postSharingSettings,
      }),
    {
      onMutate: async ({ companyId, postId, postSharingSettings }) => {
        await queryClient.cancelQueries([
          "companies",
          companyId,
          "posts",
          postId,
          "sharing_settings",
        ]);

        let previousPostSharingSettings = queryClient.getQueryData([
          "companies",
          companyId,
          "posts",
          postId,
          "sharing_settings",
        ]);

        const optimisticPostSharingSettings = postSharingSettings;

        queryClient.setQueryData(
          ["companies", companyId, "postId", postId, "sharing_settings"],
          postSharingSettings
        );

        return {
          previousPostSharingSettings,
          optimisticPostSharingSettings,
          companyId,
          postId,
        };
      },
      onError: (err, company, context) => {
        queryClient.setQueryData(
          [
            "companies",
            context.companyId,
            "posts",
            context.postId,
            "sharing_settings",
          ],
          context.previousPostSharingSettings
        );
      },
      onSettled: (data, error, variables, context) => {
        queryClient.invalidateQueries(["companies", context.companyId]);
      },
    }
  );
}
